'use client';

import type {
  MysteryRoomInventoryItemId,
  MysteryRoomResourceKind,
  MysteryRoomResourceSourceKind,
} from './mapTypes';

export const MYSTERY_ROOM_RESOURCE_KINDS: MysteryRoomResourceKind[] = ['wood', 'metal', 'stone'];

export const MYSTERY_ROOM_RESOURCE_DEFINITIONS: Record<
  MysteryRoomResourceKind,
  {
    label: string;
    icon: string;
    color: number;
    accentColor: number;
  }
> = {
  wood: {
    label: 'Дерево',
    icon: 'WD',
    color: 0x8b5a2b,
    accentColor: 0x86efac,
  },
  metal: {
    label: 'Металл',
    icon: 'MT',
    color: 0x64748b,
    accentColor: 0xf59e0b,
  },
  stone: {
    label: 'Камень',
    icon: 'ST',
    color: 0x475569,
    accentColor: 0xcbd5e1,
  },
};

export const MYSTERY_ROOM_RESOURCE_SOURCE_DEFINITIONS: Record<
  MysteryRoomResourceSourceKind,
  {
    label: string;
    resourceKind: MysteryRoomResourceKind;
    amount: number;
    width: number;
    height: number;
    color: number;
    accentColor: number;
    icon: string;
  }
> = {
  bush: {
    label: 'Куст',
    resourceKind: 'wood',
    amount: 2,
    width: 78,
    height: 58,
    color: 0x15803d,
    accentColor: 0x86efac,
    icon: 'BU',
  },
  scrap: {
    label: 'Металлолом',
    resourceKind: 'metal',
    amount: 2,
    width: 72,
    height: 52,
    color: 0x475569,
    accentColor: 0xf59e0b,
    icon: 'SC',
  },
  rock: {
    label: 'Камни',
    resourceKind: 'stone',
    amount: 2,
    width: 70,
    height: 54,
    color: 0x334155,
    accentColor: 0xcbd5e1,
    icon: 'RK',
  },
};

export function mysteryRoomResourceItemId(kind: MysteryRoomResourceKind): MysteryRoomInventoryItemId {
  return `resource_${kind}` as MysteryRoomInventoryItemId;
}

export function mysteryRoomResourceLabel(kind: MysteryRoomResourceKind): string {
  return MYSTERY_ROOM_RESOURCE_DEFINITIONS[kind]?.label ?? kind;
}
